function getKeyVal (o, checkDatasKey, sep = '.') {
  let rt = Object.assign(o)

  if (typeof checkDatasKey === 'string') {
    checkDatasKey = checkDatasKey.split(sep)
  }

  for (let i in checkDatasKey) {
    if (i > 0) {
      rt = rt[checkDatasKey[i]]
    }
  }
  return rt
}

export default  {
  twoWay: true,
  params: ['check-data', 'nest-array', 'check-key'],
  bind(el, binding, vnode) {
    let vm = vnode.context,
      checkDatasKey = vnode.data.attrs[binding.def.params[0]], // check-data的字符串 支持.分隔,
      nestArrays = vnode.data.attrs[binding.def.params[1]].split(','), // 支持多个list，','英文逗号分隔
      checkKeys = vnode.data.attrs[binding.def.params[2]].split(',') // 支持多个check，','英文逗号分隔
      
    /**
     * 如果所有的列表的checked属性都为true,则选中全选框,否则不选中全选框
     */
    vm.$watch(checkDatasKey.split('.')[0], (checkData) => {
      checkData = getKeyVal(checkData, checkDatasKey)
      
      let bool = false
      if (nestArrays.length === 0) {
        bool = checkData.every((item) => {
          return checkKeys.every(checkKey => {
            return item[checkKey]
          })
        })
      } else {
        bool = checkData.every((item) => {
          return nestArrays.every(nestKey => {
            return item[nestKey].every(data => {
              return checkKeys.every(checkKey => {
                return data[checkKey]
              })
            })
          })
        })
      }
      
      if (bool) {
        vm[binding.expression] = true
      } else {
        vm[binding.expression] = false
      }
    }, { deep: true })
    
    el.onclick = () => {
      let checkDatas = vm[checkDatasKey.split('.')[0]]
      checkDatas = getKeyVal(checkDatas, checkDatasKey)

      let checkAll = !vm[binding.expression]

      if (nestArrays.length === 0) {
        checkDatas.forEach((item) => {
          checkKeys.forEach(checkKey => {
            if (item[checkKey] === undefined) {
              vm.$set(item, checkKey, !!checkAll)
            } else {
              item[checkKey] = !!checkAll
            }
          })
        })
      } else {
        checkDatas.forEach((item) => {
          nestArrays.forEach(nestKey => {
            item[nestKey].forEach(data => {
              checkKeys.forEach(checkKey => {
                if (data[checkKey] === undefined) {
                  vm.$set(data, checkKey, !!checkAll)
                } else {
                  data[checkKey] = !!checkAll
                }
              })
            })
          })
        })
      }
      
    }
    
  },
  // checkAll发生更改时
  update(el, binding, vnode) {
    if (binding.value === binding.oldValue) return

    let checkAll = binding.value,
      vm = vnode.context,
      checkDatasKey = vnode.data.attrs[binding.def.params[0]], // check-data的字符串 支持.分隔
      checkDatas = vm[checkDatasKey.split('.')[0]],
      nestArrays = vnode.data.attrs[binding.def.params[1]].split(','), // 支持多个check，','英文逗号分隔
      checkKeys = vnode.data.attrs[binding.def.params[2]].split(',') // 支持多个check，','英文逗号分隔
      
    checkDatas = getKeyVal(checkDatas, checkDatasKey)

    let bool = false // 是否每个子checkbox都为true
    if (nestArrays.length === 0) {
      bool = checkDatas.every((item) => {
        return checkKeys.every(checkKey => {
          return item[checkKey]
        })
      })
    } else {
      bool = checkDatas.every((item) => {
        return nestArrays.every(nestKey => {
          return item[nestKey].every(data => {
            return checkKeys.every(checkKey => {
              return data[checkKey]
            })
          })
        })
      })
    }

    if (!bool) return
    
    /**
     * 如果全选框被选中,则将列表的所有checked属性转为true,否则转为false
     */
    if (nestArrays.length === 0) {
      checkDatas.forEach((item) => {
        checkKeys.forEach(checkKey => {
          if (item[checkKey] === undefined) {
            vm.$set(item, checkKey, !!checkAll)
          } else {
            item[checkKey] = !!checkAll
          }
        })
      })
    } else {
      checkDatas.forEach((item) => {
        nestArrays.forEach(nestKey => {
          item[nestKey].forEach(data => {
            checkKeys.forEach(checkKey => {
              if (data[checkKey] === undefined) {
                vm.$set(data, checkKey, !!checkAll)
              } else {
                data[checkKey] = !!checkAll
              }
            })
          })
        })
      })
    }
  }
}

